<!-- <ul class="messages" #messagesPlaceHolder></ul> -->

<section class="chat-box-container">
    <main class="chat-box">
        <div class="row" id="messagesPlaceHolder" #messagesPlaceHolder>

        </div>
    </main>
</section>




